import cookieUtils from "@/utils/cookieUtils";
import _ from "lodash";

type JsonObject = {
  [key: string]: string | number | JsonObject;
};

export const fallbackLng = {
  en_GB: ["en"],
  en_US: ["en"],
  zh_CN: ["zh"],
  zh_TW: ["en"],
  nl_NL: ["nl"],
  de_DE: ["de"],
  fr_FR: ["fr"],
  default: ["en"],
};

export const mergeObjects = (a: JsonObject, b: JsonObject) => {
  return _.merge(a, b);
};

export const getI18nLang = () => {
  return cookieUtils.getCookie("_lang");
};

export const setI18nLang = (language: string) => {
  return cookieUtils.setCookie("_lang", language, 90);
};
